import { Component, Prop, Vue } from "vue-property-decorator";
import { Radio } from "ant-design-vue";
import { MediaSlot } from "@/util/enum";
import { fmtMsg } from "commonui";
import { CommonLocale, ContentExposureLocale, REPLocale } from "@/locales/localeid";

export interface SlotRadioGroupProps {
	isEdit?: boolean;
	initValues?: any[];
}

@Component({
	components: {
		Radio,
		RadioGroup: Radio.Group
	}
})
export default class SlotRadioGroup extends Vue {
	@Prop({ default: false }) isEdit!: boolean;
	@Prop({ default: () => [] }) initValues!: any;
	@Prop({ default: true }) isRepSlot!: boolean;
	@Prop({ default: false }) isReader!: boolean;

	locale = CommonLocale;

	$refs!: {
		content: HTMLDivElement;
	};

	get mediaSlotType() {
		return MediaSlot;
	}

	get repLocale() {
		return REPLocale;
	}

	get contentExposureLocale() {
		return ContentExposureLocale;
	}

	get showError() {
		return this.initValues.length === 0;
	}

	mounted() {}

	formatMessage(id: string, params?: any): string {
		return fmtMsg(id, params);
	}
}
